import { render, staticRenderFns } from "./RescueOfCustomerService.vue?vue&type=template&id=d914967e&scoped=true&"
import script from "./RescueOfCustomerService.vue?vue&type=script&lang=js&"
export * from "./RescueOfCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./RescueOfCustomerService.vue?vue&type=style&index=0&id=d914967e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d914967e",
  null
  
)

export default component.exports